export type PublicTheme = 'dark' | 'light'

const storageKey = 'goblog.public.theme'

function applyTheme(theme: PublicTheme) {
  if (!import.meta.client) return
  document.documentElement.classList.toggle('theme-light', theme === 'light')
  document.documentElement.style.colorScheme = theme
}

/** Visual preference for public pages only; the account console keeps its own dark UI. */
export function usePublicTheme() {
  const theme = useState<PublicTheme>('public-theme', () => 'light')
  const restored = useState<boolean>('public-theme-restored', () => false)

  onMounted(() => {
    if (restored.value) return
    const saved = window.localStorage.getItem(storageKey)
    theme.value = saved === 'dark' ? 'dark' : 'light'
    restored.value = true
    applyTheme(theme.value)
  })

  function toggleTheme() {
    // A click can happen before mounted hooks finish during hydration. Marking
    // the state as restored prevents that late hook from overwriting the click.
    restored.value = true
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
    applyTheme(theme.value)
    if (import.meta.client) window.localStorage.setItem(storageKey, theme.value)
  }

  return { theme, toggleTheme }
}
